import schemaPOC from "../Shared/schemaPOC";
import schemaRest from "../Shared/schemaRest";
import schemaRestV2 from "../Shared/schemaRestV2";

const getMappingSchema = (formId) => {
  return {
    schemaPOC: schemaPOC[formId] || [],
    schemaRest: schemaRest[formId] || [],
    schemaRestV2: schemaRestV2[formId] || [],
  };
};

export default getMappingSchema;
